import * as React from 'react';

const Passport = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={40}
        height={40}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        viewBox="0 0 40 40"
        {...props}
    >
        <path
            d="M27.5 36.21a2.502 2.502 0 0 1-3.167 2.41l-17.5-4.861A2.5 2.5 0 0 1 5 31.355V4.502a2.502 2.502 0 0 1 3.167-2.41l17.5 5.651A2.5 2.5 0 0 1 27.5 10.15z"
            clipRule="evenodd"
        />
        <path d="M7.5 2h25A2.5 2.5 0 0 1 35 4.5v26.25a2.5 2.5 0 0 1-2.5 2.5h-5" />
    </svg>
);
export default Passport;
